import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

import logo from '@src/stories/assets/logo.png';

function HeaderLogo({ onClick }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={onClick}>
      <Box src={logo} component="img" alt="SecureOneLabs logo" sx={{ height: 44, width: 'auto', mr: 1 }} />
    </Box>
  );
}
HeaderLogo.propTypes = {
  onClick: PropTypes.func.isRequired,
};

HeaderLogo.displayName = 'Header.Logo';
export default HeaderLogo;
